import { render } from "./TreeTableBase.vue?vue&type=template&id=396d6472&scoped=true"
import script from "./TreeTableBase.vue?vue&type=script&lang=js"
export * from "./TreeTableBase.vue?vue&type=script&lang=js"

import "./TreeTableBase.vue?vue&type=style&index=0&id=396d6472&lang=less&scoped=true"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396d6472"]])

export default __exports__